import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, firstValueFrom } from 'rxjs';

import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard {
  private auth = inject(AuthService);
  private router = inject(Router);
  private userService = inject(UserService);

  async canActivate(): Promise<boolean | UrlTree> {
    await firstValueFrom(this.auth.isAuthenticated$.pipe(filter(isAuthenticated => isAuthenticated !== null)));
    await firstValueFrom(this.auth.user$.pipe(filter(user => user !== undefined)));

    return this.userService.isAdmin() && !this.userService.isExternalUser()
      ? true
      : this.router.parseUrl('/404');
  }
}
